import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { GetFormat, useGet } from 'sharedKernel/api'
import { Loading } from 'components/loading'
import { VisualizationScreen } from 'domain/feature/hub/EventVisualizationScreen'

export const HubResolverEventGetPage = (): JSX.Element => {
  const { eventId } = useParams()

  const request: GetFormat = {
    url: `/v1/hotsite/event/${eventId}`
  }
  const {
    data: eventData,
    isFetching: isEventFetching,
    refetch: eventRefetch
  } = useGet<any>(request, 'event-get')
  const filesRequest: GetFormat = {
    url: `/v1/hotsite/event/${eventId}/files`
  }
  const {
    data: fileData,
    isFetching: isFileFetching,
    refetch: filesRefetch
  } = useGet<any>(filesRequest, 'event-files-get')

  useEffect(() => {
    eventRefetch()
    filesRefetch()
  }, [eventId])

  const renderResponse = (): JSX.Element => {
    if (isEventFetching || isFileFetching) {
      return (
        <Loading />
      )
    }
    return (
      <VisualizationScreen
        isFetching={isEventFetching}
        data={eventData}
        isFileFetching={isFileFetching}
        fileData={fileData?.rows}
      />
    )
  }

  return <>{renderResponse()}</>
}
